import React, { Component } from 'react'
import { object, string } from 'prop-types'

class ParkingInfo extends Component {
  render () {
    const {
      productData: {
        sellingpoint = '',
        seo_information: seoInformation = '',
        transfer = '',
        transferdauer = '',
        sicherheit = '',
        pkw_groesse: pkwGroesse = '',
        kindersitz = '',
        hinweis = '',
        adresse = '',
        name = '',
        parkplatzbetreibertipp = ''
      },
      productPrice
    } = this.props

    return (
      <React.Fragment key='info'>
        {productPrice && (
          <p>
            8 Tage Parken ab
            <span className='priceSpan'> &euro; {productPrice}</span>
          </p>
        )}

        {sellingpoint && <p className='sellingpoint'>{sellingpoint}</p>}

        {seoInformation && (
          <p dangerouslySetInnerHTML={{ __html: seoInformation }} />
        )}

        {transfer && [
          <h2 key='0'>Transfer:</h2>,
          <p key='1' dangerouslySetInnerHTML={{ __html: transfer }} />
        ]}

        {transferdauer && [
          <h2 key='0'>Transferdauer:</h2>,
          <p key='1' dangerouslySetInnerHTML={{ __html: transferdauer }} />
        ]}

        {sicherheit && [
          <h2 key='0'>Sicherheit:</h2>,
          <p key='1' dangerouslySetInnerHTML={{ __html: sicherheit }} />
        ]}

        {pkwGroesse && [
          <h2 key='0'>Maximale PKW-Ma&szlig;e:</h2>,
          <p key='1' dangerouslySetInnerHTML={{ __html: pkwGroesse }} />
        ]}

        {kindersitz && [
          <h2 key='0'>kindersitz:</h2>,
          <p key='1' dangerouslySetInnerHTML={{ __html: kindersitz }} />
        ]}

        {hinweis && [
          <h2 key='0'>Bitte beachten:</h2>,
          <p key='1' dangerouslySetInnerHTML={{ __html: hinweis }} />
        ]}

        {adresse && name && ([
          <h2 key='0'>Anschrift:</h2>,
          <p key='adress' dangerouslySetInnerHTML={{ __html: adresse }} />,
          <p key='name' dangerouslySetInnerHTML={{ __html: name }} />
        ])}

        {parkplatzbetreibertipp && (
          <div className='toptipbox'>
            <span className='toptipimage' />
            <h2>Tipps vom Parkplatzbetreiber:</h2>
            <p dangerouslySetInnerHTML={{ __html: parkplatzbetreibertipp }} />
          </div>
        )}
      </React.Fragment>
    )
  }
}

ParkingInfo.propTypes = {
  productInfo: object.isRequired,
  productPrice: string.isRequired
}

export default ParkingInfo



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/de/parkingInfo.jsx